import React from 'react';
import { compose } from 'ramda';
import Grid from '@material-ui/core/Grid';
import { showToast } from '@deeptrue-frontend/ui';
import { FormikHelpers } from 'formik';
import { FormValues } from 'components/Forms/Password';
import { translateFieldErrors } from 'components/IntlProvider/translateFieldErrors';
import { useFormatMessage } from 'components/IntlProvider';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { Dashboard } from 'components/Layout';
import Forms from 'components/Forms';
import { withMetaDescription } from 'components/HeadProvider/HeadProvider';
import api from 'api/api';
import SettingsMenu from './SettingsMenu';

const { connect, actions } = StoreProvider;

const Settings = ({ updateUserProfile, location }: any) => {
  const t = useFormatMessage();

  const updatePassword = (
    values: FormValues,
    { setErrors, resetForm }: FormikHelpers<FormValues>
  ) => {
    return api.resources
      .updateUserPassword(values)
      .then(({ data }) => {
        updateUserProfile(data);

        showToast({
          type: 'success',
          title: t('errors.settings.changesSave', 'Changes saved'),
        });
        resetForm();
      })
      .catch((err) => {
        resetForm();
        setErrors(
          translateFieldErrors({
            t,
            err: err.response.data,
          })
        );
      });
  };

  return (
    <Dashboard
      title={t('profile.title', 'Settings')}
      headerTitle={t('profile.password.title', 'Password')}
      headerSubtitle={t(
        'profile.password.subtitle',
        'Here you can set a new password'
      )}
      location={location}
    >
      <Grid item xs={12}>
        <SettingsMenu />
      </Grid>
      <Grid item xs={12} sm={12} md={10} lg={6}>
        <Forms.Password
          onSubmit={updatePassword}
          initialValues={{
            current_password: '',
            new_password: '',
            new_password_confirm: '',
          }}
        />
      </Grid>
    </Dashboard>
  );
};

export default compose(
  connect(null, {
    updateUserProfile: actions.authActions.userUpdate,
  }),
  withMetaDescription({ title: 'Settings > Password' })
)(Settings);
